import { z } from "zod";

export const machineTrackMaterialSchema = z.object({
	id: z.string(),
	alias: z.string(),
});

export const machineTrackSchema = z
	.object({
		number: z.number(),
		trackNumber: z.number().optional(),
		isEmpty: z.boolean(),
		assignedMaterial: machineTrackMaterialSchema,
		trackOffset: z.number().optional(),
	})
	.passthrough();

export type MachineTrack = z.infer<typeof machineTrackSchema>;
export type MachineTrackMaterial = z.infer<typeof machineTrackMaterialSchema>;
